module.exports = __webpack_public_path__ + "media/images/aloe/icons/checkout/ground-f8881378e162f26f40a5be9e74cb00f1.svg";